export function isURL(adress) {
        const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/; // Regular expression to match common URL patterns
        return urlRegex.test(adress);
} 